import React from 'react';

import './ShowError.scss';

const ShowError = props => {

  return (
    <section
      className="ErrorModal"
      style={{
        transform: props.children ? 'translateY(0)' : 'translateY(-100vh)',
        opacity: props.children ? '1' : '0',
        backgroundColor: props.type === 'error' ? 'rgba(222, 82, 70, 0.90)' : 'rgba(36, 139, 75, 0.8)',
        ...props.style
      }}>

      {props.children}

    </section>
  );
}

export default ShowError;